<m-expansion-panel [id]="'informacaoCadastro'" [title]="'Informações cadastrais'" [active]="larguraEhSuperiorMin">
  <div *ngIf="!listaServicoFalha.includes('info-cadastrais')" id="id-table-informacaoCadastro"
    class="table table-sm table-borderless" style="font-size: smaller;">
    <div *ngIf="informacaoCadastro !== undefined">
      <!-- BLOCO DE DADOS CADASTRAIS -->
      <div class="row">
        <div class="col-md-4" id="informacaoCadastro-nome">
          <label class="etiqueta row">Nome</label>
          <span class="row descricao-etiqueta" id="id-span-informacaoCadastro-nome">{{informacaoCadastro.nome |
            naoinformado}} </span>
        </div>

        <div class="col-md-4" id="informacaoCadastro-num-cpf">
          <label class="row etiqueta">CPF</label>
          <span class="row descricao-etiqueta" id="id-span-informacaoCadastro-cpf">{{informacaoCadastro.cpf |
            naoinformado}} </span>
        </div>

        <div class="col-md-4" id="informacaoCadastro-status-documento">
          <label class="row etiqueta">Status do documento</label>
          <span class="row descricao-etiqueta"
            id="id-span-informacaoCadastro-statusReceitaFed">{{informacaoCadastro.situacao | naoinformado}}
          </span>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-4" id="informacaoCadastro-nome-mae">
          <label class="row etiqueta">Nome da mãe</label>
          <span class="row descricao-etiqueta" id="id-span-informacaoCadastro-nomeMae">{{informacaoCadastro.nomeMae |
            naoinformado}}
          </span>

        </div>
        <div class="col-md-4" id="informacaoCadastro-documento-identificacao">
          <label class="row etiqueta">Documento de identificação</label>
          <span class="row descricao-etiqueta"
            id="id-span-informacaoCadastro-docIdentificacao">{{informacaoCadastro.documentoIdentificacao |
            naoinformado}}
          </span>

        </div>
        <div class="col-md-4" id="informacaoCadastro-data-nascimento">
          <label class="row etiqueta">Data de nascimento</label>
          <span class="row descricao-etiqueta"
            id="id-span-informacaoCadastro-dataNacimento">{{informacaoCadastro.dataNascimento | naoinformado}}
          </span>
        </div>
      </div>

    </div>
    <div *ngIf="informacaoCadastro == undefined">
      {{informacaoCadastro.falhaServico.message}}
    </div>
  </div>
  <div id="id-div-informacaoCadastro-falha" *ngIf="listaServicoFalha.includes('info-cadastrais')">
    {{informacaoCadastro.falhaServico.message}}
  </div>
</m-expansion-panel>


<m-expansion-panel [id]="'dadosDeLocalizacao'" [title]="'Dados de localização'" [active]="larguraEhSuperiorMin">
  <div *ngIf="!listaServicoFalha.includes('info-cadastrais')" id="id-table-dadosDeLocalizacao"
  class="table table-sm table-borderless" style="font-size: smaller;">
  <div>
    <div class="row">
      <div class="col-md-4" id="dadosDeLocalizacao-endereco">
        <label class="row etiqueta">Endereço</label>
        <span class="row descricao-etiqueta" id="id-span-dadosDeLocalizacao-endereco">{{informacaoCadastro.endereco
          | naoinformado}} </span>
      </div>
      <div class="col-md-3" id="dadosDeLocalizacao-bairro">
        <label class="row etiqueta">Bairro</label>
        <span class="row descricao-etiqueta" id="id-span-dadosDeLocalizacao-bairro">{{informacaoCadastro.bairro |
          naoinformado}} </span>
      </div>
      <div class="col-md-3" id="dadosDeLocalizacao-cep">
        <label class="row etiqueta">CEP</label>
        <span class="row descricao-etiqueta" id="id-span-dadosDeLocalizacao-cep">{{informacaoCadastro.cep |
          naoinformado}} </span>
      </div>
      <div class="col-md-2" id="dadosDeLocalizacao-uf">
        <label class="row etiqueta">UF</label>
        <span class="row descricao-etiqueta" id="id-span-dadosDeLocalizacao-uf">{{informacaoCadastro.uf |
          naoinformado}} </span>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-4" id="dadosDeLocalizacao-cidade">
        <label class="row etiqueta">Cidade</label>
        <span class="row descricao-etiqueta" id="id-span-dadosDeLocalizacao-cidade">{{informacaoCadastro.cidade |
          naoinformado}} </span>
      </div>
      <div class="col-md-3" id="dadosDeLocalizacao-telefone">
        <label class="row etiqueta">Telefone</label>
        <span class="row descricao-etiqueta" id="id-span-dadosDeLocalizacao-telefone">{{informacaoCadastro.telefone
          | naoinformado}}
        </span>
      </div>
      <div class="col-md-4" id="dadosDeLocalizacao-email">
        <label class="row etiqueta">E-mail</label>
        <span class="row descricao-etiqueta" id="id-span-dadosDeLocalizacao-email">{{informacaoCadastro.email |
          naoinformado}} </span>
      </div>
    </div>
  </div>
</div>
<div id="id-div-dadosDeLocalizacao-falha" *ngIf="listaServicoFalha.includes('info-cadastrais')">
  {{informacaoCadastro.falhaServico.message}}</div>
</m-expansion-panel>
